import {createReducer} from 'util/redux/createReducer'
import {updateClipboardAction} from 'module/Clipboard/action/ClipbaordAction'
import {Clipboard} from 'module/Clipboard/type/ClipboardTypes'
import {appInitAction} from 'util/ReduxUtil'
import {getAndRemoveParams} from 'module/UrlParam/util/UrlParamUtil'
import {UrlParamPrefix} from 'module/UrlParam/constant/UrlParamConstant'
import {log} from 'common/log'

function parseClipboardValue(value: string) {
	try {
		return JSON.parse(value)
	} catch {
		log.error('error parsing value, using raw value', value)
	}
	return value
}

export const clipboardReducer = createReducer<Clipboard>({}, builder => builder
	.addCase(appInitAction, (state) => {
		const urlParams = getAndRemoveParams((key) => key.startsWith(UrlParamPrefix.Clipboard))
		return {
			...state,
			...Object.entries(urlParams).reduce((clipboardChanges, [key, value]) => {
				const cbKey = key.substring(UrlParamPrefix.Clipboard.length)
				clipboardChanges[cbKey] = parseClipboardValue(value)
				return clipboardChanges
			}, {} as Clipboard),
		}
	})
	.addCase(updateClipboardAction, (state, {payload: {clipboard, value}}) => ({
		...state,
		[clipboard]: value,
	})),
)

export const ClipboardReducerNS = {
	Clipboard: clipboardReducer,
};

export type ClipboardStateType = { Clipboard: ReturnType<typeof ClipboardReducerNS.Clipboard> }